export default {
  title: "Мой профиль",
  dropdown: {
    edit: "Редактировать",
  },
  message: "Если несколько языков сливаются, грамматика полученного языка будет более простой и правильной, чем грамматика отдельного человека.",
  about: {
    title: "О контакте",
    name: {
      label: "Имя",
    },
    email: {
      label: "Email",
    },
    time_zone: {
      label: "Часовой пояс",
    },
  },
}
